import React, {Component} from 'react';
import Sectiontitle from '../component/Banner/Sectiontitle';
import Fade from 'react-reveal/Fade';

class Service extends Component{
    render(){
        let ifontanaData = this.props.ifontanaData;
        var {wClass} = this.props
        return(
            <section className={`${wClass}`} id="service">
                <div className="container">
                    <Sectiontitle 
                     Title="¿Qué hacemos?" 
                     TitleP="Desarrollo de software a la medida. Arquitectura/Implementación. Integración, diseño. Soluciones Industria 4.0."/>
                    <Fade bottom cascade duration={2000}>
                        <div className="row">
                            {
                                ifontanaData.service && ifontanaData.service.map(item =>{
                                return(
                                        <div className="col-lg-4 col-sm-6" key={item.id}>
                                            <div className="work_item wow fadeInUp" data-wow-delay="0.1s">
                                                <i className={item.iconName}></i>
                                                <a href=".#"><h2 className="t_color">{item.serviceTitle}</h2></a>
                                                <p>{item.sDetails}</p>
                                            </div>
                                        </div>
                                        )
                                    }
                                )
                            }
                        </div>
                    </Fade>
                </div>
            </section>
        )
    }
}

export default Service;